const DatesInfoModalContent = [
    {
        title: "Time Deadline to Send Contract",
        content: "This is the time of day when the contract must be sent in."
    },
    {
        title: "Alternative Earnest Money Deadline",
        content: "When earnest money is due. This deposit must be turned into either the Brokerage or Title Company in either check or electronic form. The amount of the deposit is usually set by the sales contract and is typically available in the MLS.",
        mecDate: "For 30 days closing, usually 1-3 days from MEC"
    
    },
    {
        title: "Record Title Deadline",
        content: "This is a Buyer deadline if Buyer selects Title Insurance Co. and a Seller deadline if Seller selects Title Insurance Co. The deadline in which the Title Company must provide the Buyer a current commitment for an owner’s title insurance policy.",
        mecDate: "For 30 days closing, usually 10-14 days from the MEC"
    
    },
    {
        title: "Record Title Objection Deadline",
        content: "Allows the Buyer to object to the title condition. This is at the Buyer’s discretion and can therefore be based on any unsatisfactory title condition",
        mecDate: "For 30 days closing, usually 11-15 days from the MEC"
    },
    {
        title: "Off Record Title Deadline",
        content: "When the Buyer must receive copies of all existing documents in the Seller’s possession and must disclose to Buyer all easements, liens, leases, agreements or other title matters not shown by public records, of which the Seller has actual knowledge. For example, the previous owner hand wrote a lease to let someone use their backyard for grazing cows. This wouldn't show up on public record, but is an off record / not recorded by title company lease on the property.",
        mecDate: "For 30 days closing, usually 10-14 days from MEC"
    
    },
    {
        title: "Off Record Title Objection Deadline",
        content: "This is similar to the Record Title Objection. The Buyer can object & terminate if unsatisfied with documents provided in the Off Record Title Deadline.",
        mecDate: "For 30 days closing, usually 11-15 days from the MEC"
    },
    {
        title: "Title Resolution Deadline",
        content: "Date by which all title objections must be resolved.",
        mecDate: "For 30 days closing, usually 14-17 days from the MEC"
    },
    {
        title: "Right of First Refusal Deadline",
        content: "Applies to situations, where an outside entity, like an HOA, has to approve a Buyer’s contract. If the entity who holds this right disapproves the contract, the contract terminates.",
        mecDate: "*If Needed, for 30 days closing, usually 5-7 days from MEC"
    },
    {
        title: "Association Document Deadline",
        content: "Deadline for which the Buyer must receive all current HOA documents. It is VERY important for Buyers to review all documents of this nature especially in townhome or condo communities.", 
        mecDate: "*If in HOA, for 30 days closing, usually 10-14 business days from the MEC"
    },
    {
        title: "Association Documents Termination Deadline",
        content: "Gives the Buyer the right to terminate the contract based on any unsatisfactory provisions in the HOA docs.",
        mecDate: "*If in HOA, for 30 days closing, usually 10-14 business days from the MEC"
    },
    {
        title: "Seller Property Disclosure Deadline",
        content: "This is the Sellers disclosure on any issues or improvements that they have any knowledge of pertaining to the home.", 
        mecDate: "For 30 days closing, usually 1-3 days from the MEC"
    },
    {
        title: "Lead Based Paint Disclosure Deadline",
        content: "The Lead Based Paint Disclosure is important only for homes built before 1978 and does not apply if the home was built after this date. A Seller agrees to deliver the lead-based paint disclosure and the EPA Brochure “Protect Your Family From Lead in your Home” to the Buyer on or before the deadline. The Buyer will then have until the mutually agreed date to terminate the contract and receive the return of their earnest money based on the disclosure.",
        mecDate: "For 30 days closing, usually 1-3 days from the MEC"
    },
    {
        title: "New Loan Application Deadline",
        content: "Deadline in which the Buyer must submit a full loan application to the lender. In most cases,Buyers have usually gone through this process before submitting an offer.",
        mecDate: "For 30 days closing, usually 1-3 days from the MEC, can be marked as 'COMPLETE' if finalized" 
    },
    {
        title: "New Loan Terms or Termination Deadline",
        content: "To aid the Buyer determining whether the new loan is satisfactory to their needs. This includes payments, interest rate, terms, conditions, and cost. This deadline is for the sole benefit of the Buyer. This gives the buyer the opportunity to make sure the loan on the home still makes sense to move forward in the purchasing agreement.",
        mecDate: "For 30 days closing, usually 7-10 days from the MEC"
    },
    {
        title: "New Loan Availability Deadline",
        content: "This deadline is for the lender to provide the Buyer with a written loan commitment. If the lender cannot procure the loan for a number of reasons then the Buyer has the right to terminate.",
        mecDate: "For 30 days closing, usually 20-24 days from the MEC"
    },
    {
        title: "Buyers Credit Information Deadline",
        content: "Applies in the case of owner carry financing. The Buyer must supply the Seller with financials, a credit report or other documents requested.",
        mecDate: "For 30 days closing, usually 7-10 days from the MEC"
    },
    {
        title: "Disapproval of Buyers Credit Information Deadline",
        content: "Seller’s opportunity to decline the Buyer based on the information provided.",
        mecDate: "For 30 days closing, usually 10-14 days from the MEC"
    },
    {
        title: "Existing Loan Deadline",
        content: "Only applicable for if the Buyer is going to assume the Seller’ existing loan.",
        mecDate: "For 30 days closing, usually 7-10 days from the MEC"
    },

    {
        title: "Existing Loan Termination Deadline",
        content: "​​Once the Buyer receives the Seller’s current loan information, they have the right to review the terms and object or decline thereby terminating the contract.",
        mecDate: "For 30 days closing, usually 10-14 days from the MEC"
    },
    {
        title: "Loan Transfer Approval Deadline",
        content: "This deadline only applies if the Buyer is going to assume the Seller’s existing loan. This is the deadline for the Seller’s Lender to approve the loan assumed by the Buyer.",
        mecDate: "For 30 days closing, usually 21-28 days from the MEC"
    },
    {
        title: "Seller or Private Financing Deadline",
        content: "Only applies if any portion of the financing of the transaction is provided by private or seller financing. The Buyer must decide by this date if the financing being offered is acceptable.",
        mecDate: "For 30 days closing, usually 21-28 days from the MEC"
    },
    {
        title: "Appraisal Deadline",
        content: "Date in which the Buyer must receive an appraisal of the property. In most cases where there is a loan, the Lender will require an appraisal in order to determine the property’s current market value. This can be an important deadline to monitor because appraisers tend to fall behind during the busy season. This does not apply to VA loans.",
        mecDate: "Usually 18-21 days from the MEC"
    },
    {
        title: "Appraisal Objection Deadline",
        content: "*Try and keep around same date as loan termination deadline. When the Buyer must submit in writing that the valuation is less than the purchase price and outline the appraiser requirements of work to be done before it can close. (For example, Remove the chipped lead based paint from the side of the house).",
        mecDate: "For 30 days closing, usually 18-21 days from the MEC"
    },
    {
        title: "Appraisal Resolution Deadline",
        content: "If there is an appraisal objection, the Appraisal Resolution Deadline is when the objection needs to be resolved. At this point, a couple of things can occur: a) the Seller can come down in price to match the valuation; b) the Buyer can bring the difference in cash or c) the Contract can terminate.",
        mecDate: "For 30 days closing, usually 21-24 days from the MEC date"
    },
    {
        title: "New ILC or New Survey Deadline",
        content: "An Improvement Location Certificate (ILC) or Survey is usually only ordered if the title company (and in some cases the lender) requires it, or if the Buyer has questions as to where the exact property lines are. The New ILC or New Survey Deadline outlines when the Buyer must receive either document by the deadline.",
        mecDate: "For 30 days closing, usually 18-21 days from the MEC date"
    },
    {
        title: "New ILC or New Survey Objection Deadline",
        content: "Date when the Seller must receive a written description of any matter that is unsatisfactory and the Buyer requires the Seller to correct.",
        mecDate: "For 30 days closing, usually 18-21 days from the MEC date"
    },
    {
        title: "New ILC or New Survey Resolution Deadline",
        content: "If there is an ILC or Survey objection, the issue must be resolved by this date or the contract terminates. The resolution deadline must be after the objection deadline.",
        mecDate: "For 30 days closing, usually 20-24 days from the MEC"
    },
    {
        title: "Water Rights Examination Deadline",
        content: "To find out who owns water rights in Colorado, you can check the records at the county clerk and recorder's office where the property is located. This deadline affects how water rights are treated once a contract is in place. By default Shishito checks the box for the Water Rights Examination Deadline, to afford you the ability to terminate the contract based on any potential water title issues. To give yourself sufficient time to get a lawyer or water rights expert to review the water rights, we recommend setting this deadline at least 14 days from the MEC.",
        mecDate: "For 30 days closing, usually 14-17 days from the MEC"
    },
    {
        title: "Mineral Rights Examination Deadline",
        content: "To find out who owns mineral rights in Colorado, you can check the records at the county clerk and recorder's office where the property is located. This deadline affects how mineral rights are treated once a contract is in place. To give yourself sufficient time to get a lawyer or water rights expert to review the water rights, we recommend setting this deadline at least 14 days from the MEC.",
        mecDate: "For 30 days closing, usually 14-17 days from the MEC"
    },
    {
        title: "Inspection Objection Deadline",
        content: "VERY IMPORTANT The Buyer has the right to have a professional inspection done of the property. All home inspections completed by this date. The Inspection Objection Deadline is the date by which the Seller must receive a written description of any unsatisfactory physical condition that the Buyer requires the Seller to correct. For example cracks in the sewer line or foundation.",
        mecDate: "For 30 days closing, usually 7-10 days from the MEC"
    },
    {
        title: "Inspection Termination Deadline",
        content: "Only pertain if an objection is sent. If an objection is received by the Buyer, the Seller has until this date to respond in writing, addressing the repair requests from the Buyer. The Buyer has to agree to the terms or the contract terminates.",
        mecDate: "For 30 days closing, usually 7-14 days from the MEC"
    },
    {
        title: "Inspection Resolution Deadline",
        content: "If an Inspection Objection is received by the Buyer, the Seller has until this date to respond in writing addressing the each of Buyer’s repair requests. If the Buyer and Seller cannot agree to the terms or agree to withdraw the objection, the contract terminates.",
        mecDate: "For 30 days closing, usually 10-14 days from the MEC"
    },
    {
        title: "Property Insurance Termination Deadline",
        content: "If there is financing required to purchase the property, the Lender will require property insurance to be obtained, commonly called homeowner’s insurance. The Property Insurance Termination Deadline is when the Buyer must obtain as many bids as they’d like for their homeowner’s insurance. If the insurance does not meet their satisfaction, they must terminate in writing by this deadline.",
        mecDate: "For 30 days closing, usually 21-24 days from the MEC"
    },
    {
        title: "Due Diligence Documents Delivery Deadline",
        content: "In the contract, if the box is checked in the Due Diligence section, the Seller agrees to deliver copies of specific documents pertaining to the property. This can include any leases, completed contract work, warranties, permits, etc.",
        mecDate: "For 30 days closing, usually 7-10 days from the MEC"
    },
    {
        title: "Due Diligence Documents Objection Deadline",
        content: "If the Due Diligence Documents are not supplied to the Buyer, or are incomplete or unsatisfactory, the Buyer can terminate or Object. When the Buyer objects, they must provide a written description of the documents that they require the Seller to correct or supply.",
        mecDate: "For 30 days closing, usually 8-11 days from the MEC"
    },
    {
        title: "Due Diligence Documents Resolution Deadline",
        content: "If there is a Due Diligence Document Objection, the issues must be resolved or the objection retracted by the Due Diligence Documents Resolution Deadline or the contract terminates.",
        mecDate: "For 30 days closing, usually 10-14 days from the MEC"
    },
    {
        title: "Conditional Sale Deadline",
        content: "Only is applicable If the Buyer has a property to sell before they can complete the purchase of the property under contract. The contingent property must be sold and closed by the conditional sale date, or the Buyer may terminate the contract.",
        mecDate: "Flexible Date"
    },
    {
        title: "Lead Based Paint Termination Deadline",
        content: "Beginning in 2019, the Colorado Department of Regulatory Agencies added the Lead-Based Paint Termination Deadline for the Buyer to terminate the contract and receive the return of their earnest money if they are not satisfied with the lead-based paint disclosure or any of the results of the lead-based paint inspection(s).",
        mecDate: "For 30 days closing, usually 10-14 days from the MEC"
    },
    {
        title: "Closing Date",
        content: "when the loan papers are signed and the Seller delivers the deed to the Buyer. After closing the Buyer can take possession of the property on the date and time specified in the contract.",
        mecDate: "For 30 days closing, usually 30 days from the MEC"
    },
    {
        title: "Possession Date",
        content: "The Possession Date and Time is when the Buyer gets keys and the Seller is no longer allowed to enter the property. This is usually called the Delivery of Deed (DOD) and is usually the date of closing or one day after closing. If the Seller requires more time to occupy the property, a Post Closing Occupancy Agreement must be signed.",
    
    },
    {
        title: "Possession Time",
        content: "The Time of Possession"
    
    },
    {
        title: "Acceptance Deadline Date",
        content: "This is the day and time in which the Buyer requires the Seller to respond to their offer. This is typically 1 day from the date of the contract. If the Seller is offering a counterproposal, a new deadline is established on the counter proposal and a new MEC will be established.",
        mecDate: "Usually 1 day from when you send the contract to the Seller"
    },
    {
        title: "Acceptance Deadline Time",
        content: "Acceptance Deadline Time"
    },
    
    
];

export default DatesInfoModalContent;